module.exports = __webpack_public_path__ + "c5df4948d6cf76deeaf3a92ec4ce2181.MP3";